import { render, staticRenderFns } from "./DashboardCategoryIndia.vue?vue&type=template&id=8417a7a2&scoped=true"
import script from "./DashboardCategoryIndia.vue?vue&type=script&lang=js"
export * from "./DashboardCategoryIndia.vue?vue&type=script&lang=js"
import style0 from "./DashboardCategoryIndia.vue?vue&type=style&index=0&id=8417a7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8417a7a2",
  null
  
)

export default component.exports